enum FileUploadStatus {
  IDLE = 'IDLE',
  UPLOADING = 'UPLOADING',
}

export default FileUploadStatus;
